import DOMPurify from "dompurify";
import ReactQuill from "react-quill";
export default function TextEditorViewer({ value, xs, sm, md }) {
  const sanitizedValue = DOMPurify.sanitize(value ?? "");
  return (
    <ReactQuill
      value={sanitizedValue}
      readOnly={true}
      theme={"bubble"}
      style={{ overflowWrap: "break-word", wordBreak: "break-all" }}
    />
  );
}
